import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { BeforeAfter } from './components/BeforeAfter';
import { Bonuses } from './components/Bonuses';
import { Price } from './components/Price';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2020793225485829');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback (para usuarios sin JavaScript)
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2020793225485829&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    // Cleanup al desmontar
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-dark font-sans text-white selection:bg-rosa selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainPoints data-id="element-3" />
        <Solution data-id="element-4" />
        <Modules data-id="element-5" />
        <BeforeAfter data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Price data-id="element-8" />
        <Guarantee data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>

      <SocialProofPopup data-id="element-13" />
      <WhatsAppButton data-id="element-14" />
    </div>;
}